import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { useBodyScrollLock } from '../../../../../hooks/useBodyScrollLock';
import {
    Button,
    ModalFooter,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    ModalHeader,
    ModalBody,
    Label,
    Form,
    FormGroup,
    Col,
    Row,
    Card,
    CardHeader,
    CardBody,
} from 'reactstrap';
import classnames from 'classnames';
import BootstrapTable from '../../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import createNotification from '../../../../../utils/createNotification';
import ChatExample from '../../../../../components/Layout/AppHeader/Components/TabsContent/TimelineExample';
import CustomModal, { MODAL_SIZE } from '../../../../../components/Modal/Modal';
import { SavedPaymentCard } from '../../../../../components/SavedPaymentCard/SavedPaymentCard';
import './UserDetailsModal.scss';
import { AssociateMembersTable } from '../../../../Associates/AssociateMembersTable';
import { USER_ROLES } from '../../../../../utils/constants';
import W9HistoryModal from '../../../../../components/W9Approval/W9HistoryModal';
import Rodal from '../../../../../components/Rodal/Rodal';
import MyWallet from '../../../../UserPages/Profile/MyWallet/MyWallet';
import RewardsHistoryPaginatedTable from '../../../../UserPages/Profile/RewardsHistoryPaginatedTable/RewardsHistoryPaginatedTable';
import PurchaseHistoryPaginatedTable from '../../../../UserPages/Profile/PurchaseHistoryPaginatedTable/PurchaseHistoryPaginatedTable';
import SubscriptionsHost from '../../../../SubscriptionsHost/SubscriptionsHost';
import PracticeDetailsModal from './PracticeDetailsModal';
import Loader from 'react-loaders';
import { useStateSelector } from '../../../../../store/selectors';
import { Tooltip } from 'react-tooltip';
import ConfirmationModal from '../../../../../components/Modal/ConfirmationModal';
import { OwnerTypeEnum } from '../../../../../wallet/models/OwnerTypeEnum';
import UserDocumentsTable from '../../../../../components/UserDocumentsTable/UserDocumentsTable';
import DonationHistory from '../../../../../components/PaymentHistory/DonationHistory';
import UserBasicDetails, { UserBasicDetailsData } from './UserBasicDetails';
import MyReferralsAndInvitees from '../../../../Referal/ReferralsAndInvitees/ReferralsAndInvitees';
import { DiscountCodeTypes } from '../../../../Referal/Model/Referral/DiscountCodeType';
import { WalletOwnerType } from '../../../../Referal/Model/Referral/DiscountCode';
import { PRACTICE_OWNERSHIP_TYPES } from '../../../../../utils/constants/PracticeOwnerType.enum';
import {
    ReceiptPopup,
    ReceiptViewMode,
} from '../../../../../components/Receipts/ReceiptPopup';
import Helpers from '../../../../../utils/helper';
import NotificationSettings from '../../../../Dashboard/Notifications/NotificationSettings';
import { NotificationRolesEnum } from '../../../../../models/EventsDigestNotifier/DigestNotificationTypeEnum';

const customStyles = { marginTop: '23px' };

interface UserDetailsModalProps {
    isVisible: boolean;
    userID: number;
    onClose: () => void;
    onMemberAfiliationUpdate?: () => void;
}

interface UserDetailsData extends UserBasicDetailsData {
    practices?: any[];
    documents?: any[];
    referrerName?: string;
    isReferralPartner?: boolean;
    referrarDetails?: any;
    isSuspended?: boolean;
    actingPrimaryBuyerForUserId?: number;
}

const UserDetailsModal = (props: UserDetailsModalProps) => {
    const [activeTab, setActiveTab] = useState('1');
    const axios = useStateSelector((state) => state.core.axios);
    const [userData, setUserData] = useState<UserDetailsData>(
        {} as UserDetailsData
    );
    const [isUserDataLoading, setIsUserDataLoading] = useState(false);
    const [documents, setDocuments] = useState<any[]>([]);
    const [regPractise, setRegPractise] = useState<any[]>([]);
    const [referrarName, setReferrarName] = useState('');
    const [referralDetails, setReferralDetails] = useState<any>({});
    const [isReferralPartner, setIsReferralPartner] = useState(false);
    const [changeLogData, setChangeLogData] = useState<any[]>([]);
    const [rowToDelete, setRowToDelete] = useState<any>(null);
    const [rowToBlock, setRowToBlock] = useState<any>(null);
    const [selectedTransactionId, setSelectedTransactionId] = useState<
        string | null
    >(null);
    const [memberPaymentMethod, setMemberPaymentMethod] = useState<any>(null);
    const [memberSubscription, setMemberSubscription] = useState<any>(null);
    const [isReceiptVisible, setIsReceiptVisible] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isConfirmationDialogVisible, setIsConfirmationDialogVisible] =
        useState(false);
    const [practiceIdToConvertToFormer, setPracticeIdToConvertToFormer] =
        useState<number | false>(false);
    const [isNonprofitAdmin, setIsNonprofitAdmin] = useState(false);

    const memberNotificationRoles = useMemo(() => {
        if (!userData) return [];
        const roles = [];
        if (userData.practiceOwnerType === PRACTICE_OWNERSHIP_TYPES.INDEPENDENT)
            roles.push(NotificationRolesEnum.CurrentPracticeOwner);
        if (userData.practiceOwnerType === PRACTICE_OWNERSHIP_TYPES.FORMER)
            roles.push(NotificationRolesEnum.FormerPracticeOwner);
        if (userData.practiceOwnerType === PRACTICE_OWNERSHIP_TYPES.CORPORATE)
            roles.push(NotificationRolesEnum.CorporatePracticeOwner);
        if (userData.groups?.length > 0)
            roles.push(NotificationRolesEnum.PmgMember);
        if (userData.pocGroup)
            roles.push(NotificationRolesEnum.PocMember);
        if (userData.isReferralPartner)
            roles.push(NotificationRolesEnum.ReferralPartner);
        if (userData.isMarketplaceBroker)
            roles.push(NotificationRolesEnum.Broker);
        if (userData.isMarketplaceBuyer)
            roles.push(NotificationRolesEnum.Buyer);
        return roles;
    }, [userData]);

    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const deleteUserHandler = () => {
        let row = {
            email: userData.email,
            phone: userData.phone,
            id: userData.id,
            username: '',
        };
        setRowToDelete(row);
    };

    const cancelDelete = () => {
        if (!isDeleting) {
            setRowToDelete(null);
        }
    };

    const blockUserHandler = () => {
        let row = {
            email: userData.email,
            phone: userData.phone,
            id: userData.id,
            username: '',
        };
        setRowToBlock(row);
    };

    const cancelBlock = () => {
        setRowToBlock(null);
    };

    const convertPracticeToFormer = () => {
        axios
            .put(
                `/api/Practice/ConvertToFormer/${practiceIdToConvertToFormer}/${props.userID}`
            )
            .then(() => {
                fetchUsersDetailsData(props.userID);
            })
            .catch(function (error) {
                createNotification(error, 'error');
            });
    };

    const columns = [
        {
            dataField: 'name',
            text: 'Practice Name',
        },
        {
            dataField: 'practiceOwnershipType',
            text: 'Practice Status',
            formatter: (cellContent: any, row: any) => {
                return cellContent == PRACTICE_OWNERSHIP_TYPES.FORMER ? (
                    <>Former Practice</>
                ) : (
                    <>
                        Current Practice{' '}
                        <FontAwesomeIcon
                            id={'info' + row.id}
                            onClick={() => {
                                setIsConfirmationDialogVisible(true);
                                setPracticeIdToConvertToFormer(row.id);
                            }}
                            icon={faClockRotateLeft}/>{' '}
                        <Tooltip
                            anchorId={'info' + row.id}
                            className="tooltip-content"
                            id="event"
                            place="right">
                            <div>Make Emeritus Practice</div>
                        </Tooltip>
                    </>
                );
            },
        },
        {
            dataField: 'practiceOwnerEmail',
            text: 'Practice Owner Email',
        },
        {
            dataField: 'registrationDate',
            text: 'Registered Date',
            formatter: (cellContent: any) =>
                cellContent
                    ? new Date(cellContent).toLocaleString('en-US')
                    : '',
        },
    ];

    const expandRow = {
        renderer: (row: any) => (
            <div className="registered-practice-expand">
                <PracticeDetailsModal
                    isVisible={true}
                    renderInline={true}
                    onClose={() => {}}
                    practiceId={row.id || row.practiceID}
                    userId={props.userID}
                />
            </div>
        ),
        showExpandColumn: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: any) => {
            if (isAnyExpands) {
                return <b>-</b>;
            }
            return <b>+</b>;
        },
        expandColumnRenderer: ({ expanded }: any) => {
            if (expanded) {
                return <b style={{ cursor: 'pointer' }}>-</b>;
            }
            return <b style={{ cursor: 'pointer' }}>+</b>;
        },
    };

    const suspendUser = () => {
        axios
            .post('/api/Users/SuspendUser?userId=' + userData.id)
            .then((result) => {
                if (result && result.data && result.data.data) {
                    setUserData(result.data.data);
                }
            });
    };

    const documentsDetails = () => {
        return (
            <UserDocumentsTable
                documents={documents}
                userId={props.userID}
                refrechDocumentsList={() => fetchUsersDetailsData(props.userID)}
            />
        );
    };

    const practiseDetails = () => {
        return (
            <BootstrapTable
                keyField="practiceID"
                data={regPractise}
                columns={columns}
                expandRow={expandRow}
            />
        );
    };

    const renderNonprofitIcon = (discountCode: any) => (
        <>
            <svg
                className="nonprofit-icon"
                data-tooltip-html="Nonprofit Discount Code"
                id={`nonprofit-discount-code-${discountCode.code}`}
                xmlns="http://www.w3.org/2000/svg"
                height="62"
                viewBox="0 -960 960 960"
                width="62">
                <path
                    fill="#535bd6"
                    d="M630.615-472.154 480.462-615.231q-25.354-24.389-42.293-54.594-16.938-30.206-16.938-65.79 0-42.744 29.295-73.565Q479.821-840 522.462-840q33.23 0 60.461 19.423t47.692 46.192q20.462-26.769 47.308-46.192Q704.769-840 738.769-840q42.641 0 71.936 30.82Q840-778.359 840-735.615q0 35.488-17.481 65.611Q805.038-639.88 780-615.231L630.615-472.154Zm0-41.462 124.874-120.813q21.398-20.348 37.57-45.507 16.172-25.158 16.172-55.679 0-30.308-20.178-51.962-20.177-21.654-50.284-21.654-27.238 0-48.311 16.769-21.073 16.77-37.919 38.923l-21.924 28.847-22.692-28.847q-16.077-22.153-37.15-38.923-21.073-16.769-48.311-16.769-30.107 0-50.284 21.654Q452-765.923 452-735.615q0 30.521 15.787 55.679 15.788 25.159 38.213 45.782l124.615 120.538ZM245-204.615 560.462-110l244.153-75.692q1.539-23.846-11.12-35.039-12.659-11.192-29.341-11.192h-192.94q-19.753 0-40.253-2.115-20.5-2.116-40.884-9.424L401-270.923l12.077-31.77 87.077 32q15.615 6.308 35.192 7.539 19.577 1.231 46.731.461h26q0-23.307-10.923-37.269-10.923-13.961-27.846-20.423l-222.616-83-4.615-1.154q-1.539-.384-3.846-.384H245v200.308ZM96.154-120v-315.693h240.172q5.469 0 10.11 1.154 4.641 1.154 9.487 2.077l223.385 82.769q24.154 8.616 42.192 30.385 18.039 21.769 18.039 56.615h124.615q36.667 0 56.256 24.693Q840-213.308 840-180v18.308L563.923-77.231 245-171.615V-120H96.154Zm30.769-30.769h86.308v-254.154h-86.308v254.154Zm503.692-573.923Z"
                />
            </svg>
            <Tooltip
                place={'top'}
                className={'tooltip-content place-top'}
                anchorId={`nonprofit-discount-code-${discountCode.code}`}
                classNameArrow="arrow"
                offset={10}
            />
        </>
    );

    const referralData = () => {
        return (
            <div className="user-details-referral-data">
                {referrarName != '' ? (
                    <Form>
                        <FormGroup row>
                            <Label for="name" sm={4}>
                                Referred By:
                            </Label>
                            <Label for="name" sm={8}>
                                {referrarName}
                            </Label>
                        </FormGroup>
                    </Form>
                ) : (
                    ''
                )}
                {isReferralPartner ? (
                    <>
                        <Form>
                            <FormGroup row>
                                <Label for="name" sm={4}>
                                    Referrer Code:
                                </Label>
                                <Col sm={8} className="center-container">
                                    <div>
                                        <Label for="name">
                                            {referralDetails.referralCode}
                                        </Label>
                                    </div>
                                    {referralDetails.subCodes
                                        .filter((s: any) => s.isPrimary)
                                        .map((s: any) => (
                                            <div>
                                                <Label for="name">
                                                    {s.code}
                                                    {renderNonprofitIcon(s)}
                                                </Label>
                                            </div>
                                        ))}
                                </Col>
                            </FormGroup>
                            {referralDetails.subCodes.filter(
                                (s: any) => !s.isPrimary
                            )?.length > 0 ? (
                                <div>
                                    <FormGroup row>
                                        <Label for="name" sm={4}>
                                            Sub-Codes:
                                        </Label>

                                        <Col sm={8}>
                                            {referralDetails.subCodes
                                                .filter((s: any) => !s.isPrimary)
                                                .map((s: any) => (
                                                    <Row className="mb-2 sub-code-row">
                                                        <Col sm={3}>
                                                            <Label className="mb-0">
                                                                {s.code}
                                                                {s.ownerWalletType ===
                                                                    WalletOwnerType.Charity &&
                                                                referralDetails.subCodes.some(
                                                                    (sc: any) =>
                                                                        sc.ownerWalletType !==
                                                                        WalletOwnerType.Charity
                                                                )
                                                                    ? renderNonprofitIcon(
                                                                          s
                                                                      )
                                                                    : []}
                                                            </Label>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <Label className="mb-0">
                                                                {
                                                                    DiscountCodeTypes.find(
                                                                        (t) =>
                                                                            t.id ==
                                                                            s.codeType
                                                                    ).name
                                                                }
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                ))}
                                        </Col>
                                    </FormGroup>
                                </div>
                            ) : (
                                []
                            )}
                        </Form>
                        <MyReferralsAndInvitees
                            referredPartyEmail=""
                            primaryCode={referralDetails.referralCode}
                            userId={props.userID}/>
                    </>
                ) : (
                    ''
                )}
            </div>
        );
    };

    useBodyScrollLock(props.isVisible);

    useEffect(() => {
        fetchUsersDetailsData(props.userID);
        fetchChangeLoggData(props.userID);
        axios.get(`/api/wallet/paymentMethod/${props.userID}`).then((response) => {
            if (response.data && response.data.lastDigits) {
                setMemberPaymentMethod(response.data);
            }
        });
        axios.get(`/api/UserSubscriptions/${props.userID}`).then((response) => {
            if (response.status === 200 && response.data?.id) {
                setMemberSubscription(response.data);
            }
        });
    }, [props.userID, props.isVisible]);

    // API CALLS

    const fetchUsersDetailsData = (userID: number) => {
        setIsUserDataLoading(true);

        return axios.get('/api/Users/GetUserDetails?userId=' + userID)
            .then((response: any) => {
                if (response && response.isError) {
                    console.log(response.message);
                } else {
                    let userD = response.data.data;
                    userD.practices?.forEach((practice: any) => {
                        practice.id = practice.practiceID;
                    });
                    setUserData(userD);
                    setDocuments(userD.documents
    .filter((x: any) => x.timeOfUpload != null)
    .sort(
        (a: any, b: any) =>
            new Date(b.timeOfUpload).getTime() -
            new Date(a.timeOfUpload).getTime()
    ));
                    const mappedPractices = userD.practices?.map((practice: any) => ({
                        ...practice,
                        principalOwnerPhone: Helpers.trimPhoneNumberFromMask(
                            practice.principalOwnerPhone
                        ),
                    })) ?? [];
                    setRegPractise(mappedPractices);
                    setReferrarName(userD.referrerName);

                    if (userD.isReferralPartner) {
                        setIsReferralPartner(
                            userD.isReferralPartner &&
                                userD.referrarDetails?.isReferralAgreementSigned
                        );
                        if (userD.referrarDetails != null) {
                            setReferralDetails(userD.referrarDetails);
                        }
                    }
                    setIsNonprofitAdmin(
                        userD.roleId === USER_ROLES.CHARITY_ADMIN
                    );
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setIsUserDataLoading(false);
            });
    };

    const fetchChangeLoggData = (userID: number) => {
        axios
            .get('/api/EventLog/GetAllLogs?userId=' + userID)
            .then((response: any) => {
                if (response && response.isError) {
                    console.log(response.message);
                } else {
                    let logData = response.data.data;

                    let data: any[] = [];
                    let logText = '';
                    let logDate = '';
                    let badgeColor = '';

                    logData.forEach((element: any) => {
                        if (element.eventId === 1) {
                            logText = 'User Registered';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-success';
                        } else if (element.eventId === 2) {
                            logText = 'Practice Registration Done';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-warning';
                        } else if (element.eventId === 3) {
                            logText = 'NDA Signing Done';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-danger';
                        } else if (element.eventId === 4) {
                            logText = 'Referral Partner Registartion Done';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-primary';
                        } else if (element.eventId === 5) {
                            logText = 'Referral Partner Agreement Signing Done';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-success';
                        } else if (element.eventId === 6) {
                            logText = 'Referral Invitations Done';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-warning';
                        } else if (element.eventId === 7) {
                            logText = 'Password Reset Done';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-danger';
                        } else if (element.eventId === 8) {
                            logText = 'Account Details Updation';
                            badgeColor =
                                'badge badge-dot badge-dot-xl badge-primary';
                        }

                        logDate = new Date(
                            element.createdOn
                        ).toLocaleDateString('en-US');

                        data.push({
                            text: logText,
                            date: logDate,
                            badgeColor: badgeColor,
                        });
                    });

                    setChangeLogData(data);
                }
            })
            .catch((err) => console.log(err));
    };

    const blockUser = (row: any) => {
        axios
            .post('/api/Users/BlockUser', {
                email: row.email,
                phone: row.phone,
                userID: row.id,
            })
            .then((response) => {
                if (response && response.data && !response.data.isError) {
                    createNotification('User blocked successfully!', 'success');
                } else {
                    createNotification(
                        'User could not be blocked. Please try again later or contact the Administrator for help',
                        'error'
                    );
                }
                cancelBlock();
                window.location.reload();
            })
            .catch((err) => {
                createNotification(
                    'User could not be blocked. Please try again later or contact the Administrator for help',
                    'error'
                );
                console.log({ err });
                cancelBlock();
            });
    };

    const disableUser = (row: any) => {
        setIsDeleting(true);

        axios
            .post('/api/Users/InvalidateUser', {
                email: row.email,
                phone: row.phone,
                userID: row.id,
                username: row.username,
            })
            .then((response) => {
                if (response.status === 200) {
                    createNotification('User removed successfully!', 'success');
                    window.location.reload();
                } else {
                    createNotification(
                        'User could not be removed. Something went wrong',
                        'error'
                    );
                }
                cancelDelete();
                setIsDeleting(false);
            })
            .catch((err) => {
                createNotification(
                    'User could not be removed. Please try again later or contact the Administrator for help',
                    'error'
                );
                console.log({ err });
                cancelDelete();
            });
    };

    const forgotPasswordHandler = () => {
        axios
            .post('api/auth/AdminSetUserPassword', {
                username: userData.email,
                password: null,
            })
            .then((response: any) => {
                if (
                    response &&
                    response.response &&
                    response.response.data &&
                    response.response.data.isError
                ) {
                    createNotification(response.response.data.message, 'error');
                } else {
                    createNotification(
                        'Password reset request generated sucessfully. Please enter the verification code and new password.',
                        'success'
                    );
                }
            })
            .catch((error) => {
                createNotification(error.message, 'error');
            });
    };

    const isUserAbleToHaveMembers = (roleId: number) => {
        if (
            roleId != USER_ROLES.PRACTICE_SECONDARY_USER &&
            roleId != USER_ROLES.USER
        ) {
            return true;
        } else {
            return false;
        }
    };

    const renderLoader = () => {
        return (
            <div
                className="loader-container"
                style={{ width: '65vw', height: '10vw' }}>
                <div className="loader-container-inner">
                    <div className="text-center">
                        <Loader
                            active={isUserDataLoading}
                            type="ball-scale-multiple"
                        />
                    </div>
                    <h6 className="mt-5">Loading your data...</h6>
                </div>
            </div>
        );
    };

    const onOpenReceiptClick = (transactionId: string) => {
        setSelectedTransactionId(transactionId);
        setIsReceiptVisible(true);
    };

    return (
        <Fragment>
            <Rodal
                width={1285}
                height={1000}
                visible={props.isVisible}
                animation={'slideRight'}
                showCloseButton={true}
                customStyles={customStyles}
                className={'cls-user-details-modal'}
                onClose={() => {
                    props.onClose();
                }}
                showMask={false}>
                <ModalHeader>Member Details</ModalHeader>
                <ModalBody>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '1',
                                })}
                                onClick={() => {
                                    toggle('1');
                                }}>
                                Basic Details
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '2',
                                })}
                                onClick={() => {
                                    toggle('2');
                                }}>
                                Documents
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '3',
                                })}
                                onClick={() => {
                                    toggle('3');
                                }}>
                                Subscriptions
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '4',
                                })}
                                onClick={() => {
                                    toggle('4');
                                }}>
                                Referral Info
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '5',
                                })}
                                onClick={() => {
                                    toggle('5');
                                }}>
                                Registered Practice
                            </NavLink>
                        </NavItem>
                        {userData &&
                        (isUserAbleToHaveMembers(userData.roleId) || userData.isActingPrimaryBuyer) ? (
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTab === '6',
                                    })}
                                    onClick={() => {
                                        toggle('6');
                                    }}>
                                    Team Members
                                </NavLink>
                            </NavItem>
                        ) : (
                            ''
                        )}
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '7',
                                })}
                                onClick={() => {
                                    toggle('7');
                                }}>
                                Transaction History
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '8',
                                })}
                                onClick={() => {
                                    toggle('8');
                                }}>
                                Change Log
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '9',
                                })}
                                onClick={() => {
                                    toggle('9');
                                }}>
                                Activites on User profile
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '10',
                                })}
                                onClick={() => {
                                    toggle('10');
                                }}>
                                W-9
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === '11',
                                })}
                                onClick={() => {
                                    toggle('11');
                                }}>
                                Notification Settings
                            </NavLink>
                        </NavItem>
                    </Nav>
                    {isUserDataLoading ? (
                        renderLoader()
                    ) : (
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1" className="user-info-tab">
                                {userData ? (
                                    <UserBasicDetails
                                        renderLoader={renderLoader()}
                                        onMemberAfiliationUpdate={
                                            props.onMemberAfiliationUpdate
                                        }
                                        userData={userData}
                                        subscription={memberSubscription}
                                    />
                                ) : (
                                    ''
                                )}
                            </TabPane>
                            <TabPane tabId="2" className="documents-tab">
                                {documentsDetails()}
                            </TabPane>
                            <TabPane tabId="3" className="subscriptions-tab">
                                <SubscriptionsHost
                                    preselectedMemberId={props.userID}
                                />
                            </TabPane>
                            <TabPane tabId="4">{referralData()}</TabPane>
                            <TabPane
                                tabId="5"
                                className="registered-practice-tab">
                                {regPractise.length > 0 ? (
                                    practiseDetails()
                                ) : (
                                    <div className="empty-msg">
                                        No Data found
                                    </div>
                                )}
                            </TabPane>
                            <TabPane
                                tabId="6"
                                className="associate-member-details">
                                {userData.id ? (
                                    <AssociateMembersTable
                                        currentUserId={
                                            userData.isActingPrimaryBuyer && userData.actingPrimaryBuyerForUserId
                                                ? userData.actingPrimaryBuyerForUserId
                                                : userData.id
                                        }
                                        summaryData={userData}
                                        isMarketplaceBuyer={userData.isMarketplaceBuyer || userData.isActingPrimaryBuyer || false}
                                        isAdminView={true}
                                        isShortView={true}
                                        getSummaryData={
                                            fetchUsersDetailsData
                                        }/>
                                ) : (
                                    ''
                                )}
                            </TabPane>
                            <TabPane tabId="7" className="wallet-tables">
                                <Card className="table-section mb-3">
                                    <CardHeader>
                                        <span className="practice-heading">
                                            {'Payment Method'}
                                        </span>
                                    </CardHeader>
                                    <CardBody>
                                        {memberPaymentMethod ? (
                                            <SavedPaymentCard savedCard={memberPaymentMethod} />
                                        ) : (
                                            <div className="empty-msg">No payment method on file</div>
                                        )}
                                    </CardBody>
                                </Card>
                                <Card className="table-section mb-3">
                                    <CardHeader>
                                        <span className="practice-heading">
                                            {'Wallet'}
                                        </span>
                                    </CardHeader>
                                    <CardBody>
                                        <MyWallet
                                            ownerType={OwnerTypeEnum.User}
                                            selectedTransactionId={
                                                selectedTransactionId
                                            }
                                            onTransactionIdClick={
                                                setSelectedTransactionId
                                            }
                                            isAdminAccess={true}
                                            walletId={props.userID}/>
                                    </CardBody>
                                </Card>

                                <Card className="table-section mb-3">
                                    <CardHeader>
                                        <span className="practice-heading">
                                            {'Rewards History'}
                                        </span>
                                    </CardHeader>
                                    <CardBody>
                                        <RewardsHistoryPaginatedTable
                                            selectedTransactionId={
                                                selectedTransactionId
                                            }
                                            onTransactionIdClick={
                                                setSelectedTransactionId
                                            }
                                            isAdminAccess={true}
                                            userId={
                                                props.userID
                                            }/>
                                    </CardBody>
                                </Card>

                                {isNonprofitAdmin ? (
                                    []
                                ) : (
                                    <>
                                        <Card className="table-section mb-3">
                                            <CardHeader>
                                                <span className="practice-heading">
                                                    {'Purchase History'}
                                                </span>
                                            </CardHeader>
                                            <CardBody>
                                                <PurchaseHistoryPaginatedTable
                                                    selectedTransactionId={
                                                        selectedTransactionId
                                                    }
                                                    onTransactionIdClick={
                                                        setSelectedTransactionId
                                                    }
                                                    isAdminAccess={true}
                                                    walletId={props.userID}
                                                    onOpenReceiptClick={
                                                        onOpenReceiptClick
                                                    }/>
                                            </CardBody>
                                        </Card>
                                        <Card className="table-section mb-3">
                                            <CardHeader>
                                                <span className="practice-heading">
                                                    {'Donation History'}
                                                </span>
                                            </CardHeader>
                                            <CardBody>
                                                <DonationHistory
                                                    userId={props.userID}
                                                    selectedTransactionId={
                                                        selectedTransactionId
                                                    }
                                                    onTransactionIdClick={
                                                        setSelectedTransactionId
                                                    }
                                                    type="UsersDonationHistory"/>
                                            </CardBody>
                                        </Card>
                                    </>
                                )}
                            </TabPane>
                            <TabPane tabId="8">
                                {changeLogData.length > 0 ? (
                                    <ChatExample
                                        data={changeLogData}/>
                                ) : (
                                    <div className="empty-msg">
                                        No Data found
                                    </div>
                                )}
                            </TabPane>
                            <TabPane tabId="9">
                                <Form>
                                    <FormGroup row>
                                        <Label for="name" sm={4}>
                                            To reset user's Password:{' '}
                                        </Label>
                                        <Col sm={8}>
                                            <Button
                                                onClick={forgotPasswordHandler}
                                                size="large"
                                                color="success">
                                                Submit
                                            </Button>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={4}>
                                            To delete user:{' '}
                                        </Label>
                                        <Col sm={8}>
                                            disabled
                                            {/*<Button
                                                onClick={deleteUserHandler}
                                                size="large"
                                                color="success">
                                                Click here
                                            </Button>*/}
                                        </Col>
                                    </FormGroup>

                                    <FormGroup row>
                                        <Label for="name" sm={4}>
                                            To block user:{' '}
                                        </Label>
                                        <Col sm={8}>
                                            <Button
                                                onClick={blockUserHandler}
                                                size="large"
                                                color="success">
                                                Click here
                                            </Button>
                                        </Col>
                                    </FormGroup>
                                    {userData.roleId != 2 && (
                                        <FormGroup row>
                                            <Label for="name" sm={4}>
                                                To{' '}
                                                {userData.isSuspended
                                                    ? 'unsuspend'
                                                    : 'suspend'}{' '}
                                                user:{' '}
                                            </Label>
                                            <Col sm={8}>
                                                <Button
                                                    onClick={() => {
                                                        suspendUser();
                                                    }}
                                                    size="large"
                                                    color="success">
                                                    {userData.isSuspended
                                                        ? 'Unsuspend'
                                                        : 'Suspend'}
                                                </Button>
                                            </Col>
                                        </FormGroup>
                                    )}
                                </Form>
                            </TabPane>
                            <TabPane tabId="10" className="w9-tab">
                                <Form>
                                    <div className="w9-approval">
                                        <W9HistoryModal
                                            isVisisble={true}
                                            isTableMode={true}
                                            name={userData.name}
                                            userId={props.userID}/>
                                    </div>
                                </Form>
                            </TabPane>
                            <TabPane tabId="11">
                                <NotificationSettings
                                    userId={props.userID}
                                    isReadonly={true}
                                    notificationRoles={memberNotificationRoles}
                                    notificationsAvailable={userData?.hasPaidSubscription}
                                />
                            </TabPane>
                        </TabContent>
                    )}
                </ModalBody>
                <ModalFooter/>
            </Rodal>

            {rowToDelete && (
                <ConfirmationModal
                    isVisible={true}
                    setIsVisible={() => cancelDelete()}
                    header={`Delete User: ${rowToDelete.name}`}
                    confirmationText={
                        'This action may not be reversible. Please use caution when deleting any user. Do you really want to delete?'
                    }
                    onConfirm={() => disableUser(rowToDelete)}
                    nextButtonText={'Yes, Delete User'}
                    closeOnConfirm={false}
                    cancelButtonText={'No'}
                    isLoading={isDeleting}
                    isConfirmationDanger={true}
                />
            )}

            {rowToBlock && (
                <CustomModal
                    setVisible={cancelBlock}
                    title={'Block User'}
                    modalSize={MODAL_SIZE.MEDIUM}
                    visible={true}
                    buttons={[
                        {
                            title: 'No',
                            onClick: cancelBlock,
                            color: 'primary',
                            isEnabled: true,
                        },
                        {
                            title: 'Yes, Block User',
                            onClick: () => blockUser(rowToBlock),
                            color: 'danger',
                            isEnabled: true,
                        },
                    ]}>
                    <Label>Do you really want to block?</Label>
                </CustomModal>
            )}

            {isConfirmationDialogVisible && (
                <ConfirmationModal
                    header={`Confirmation`}
                    isVisible={isConfirmationDialogVisible}
                    setIsVisible={setIsConfirmationDialogVisible}
                    confirmationText={`Are you sure you want to make this practice Emeritus?`}
                    params={undefined}
                    onConfirm={() => {
                        convertPracticeToFormer();
                    }}
                    nextButtonText="Yes, I'm sure"
                    cancelButtonText="No, take me back"/>
            )}

            {isReceiptVisible && (
                <ReceiptPopup
                    isVisible={isReceiptVisible}
                    onClose={() => setIsReceiptVisible(false)}
                    transactionId={selectedTransactionId}
                    mode={ReceiptViewMode.TransactionView}
                    userId={userData.id}
                    isThirdPartyView={true}
                />
            )}


        </Fragment>
    );
};
export default UserDetailsModal;
